export default {
  nft: {
    traits: '특성',
    creator: '크리에이터',
    tokenId: '토큰 ID',
    contract: '컨트랙트',
    noNfts: 'NFT를 찾을 수 없습니다.',
    notFound: 'NFT를 찾을 수 없습니다',
    description: '설명'
  },
  home: {
    stats: {
      injSupply: {
        marketCap: '시가총액',
        totalStaked: '현재 총 스테이킹',
        currentSupply: 'INJ 순환 공급급',
        tooltipContent:
          '현재 INJ 공급량 100%가 유통되고 있음. 보고된 유통 공급량:'
      },
      transactions: {
        blockTime: '블록 타임',
        blockHeight: '블록 높이',
        totalTransactions: '총 트랜잭션'
      },
      assets: {
        tvl: '총 자산 가치',
        numberOfAssets: '자산 수',
        numberOfWallets: '지갑 수'
      },
      staked: {
        apr: '스테이킹 APR',
        total: '총 스테이킹',
        injBurned: '소각된 INJ'
      }
    }
  },
  block: {
    table: {
      block: {
        proposer: '제안자',
        height: '블록 높이',
        timestamp: '타임스탬프',
        'height-or-time': '높이/시간',
        transactions: '트랜잭션',
        'proposer-or-txs': '제안자/Txs'
      }
    },
    hash: '블록 해시',
    proposer: '제안자',
    title: '블록 디테일',
    height: '블록 높이',
    recentBlocks: '최근 블록',
    updateBlocks: '업데이트 블록',
    notFoundDescription: '다시 시도해 주세요.',
    invalidTitle: '죄송합니다! 다음 블록 포맷이 올바르지 않습니다.:',
    invalidDescription: '블록 높이를 올바르게 다시 입력하세요.',
    notFoundTitle: '죄송합니다, {network}에서 이 블록을 찾을 수 없습니다.:',
    stats: {
      blockTime: '블록 타임',
      blockHeight: '블록 높이',
      blockCount: '블록 카운트 (지난 24시간)',
      transactions: '트랜잭션 (지난 24시간)'
    }
  },
  assets: {
    table: {
      denomHolders: {
        value: '가치',
        address: '주소',
        quantity: '수량',
        percentage: '퍼센트'
      },
      smartContract: {
        token: '토큰',
        'contract-address': '컨트랙트 주소'
      },
      assets: {
        token: '토큰',
        price: '가격',
        'total-usd-value': 'USD 가치',
        'current-supply': '현재 공급'
      }
    },
    name: '이름',
    type: '유형',
    denom: '식별자',
    price: '가격',
    token: '토큰',
    value: '가치',
    admin: '관리자',
    title: '자산',
    native: '네이티브',
    decimal: '소수점점',
    overview: '개요',
    usdValue: 'USD 가치',
    allAssets: '모든 자산',
    assetType: '자산 타입',
    assetDetail: '자산 상세',
    totalAssets: '총 자산',
    searchToken: '토큰 검색',
    currentSupply: '현재 공급',
    insuranceFund: '보험 기금',
    smartContracts: '스마트 컨트랙트',
    adapterAddress: '어댑터 주소',
    creatorAddress: '크리에이터 주소',
    contractAddress: '컨트랙트 주소',
    submitTokenInfo: '토큰 정보 제출',
    totalAssetValue: '총 자산 가치',
    tokenVerification: '토큰 검증',
    assetsOnInj: '인젝티브 체인 내 자산',
    includeUnknownTokens: '알 수 없는 토큰 포함',
    stakedAssetValue: '스테이킹 자산 가치 (INJ)',
    totalOnchainAssets: '총 온체인 자산',
    submitTokenMetadata: '토큰 메타데이터 제출',
    assetsOnSmartContracts: '스마트 컨트랙트 내 자산',
    currentSupplyTimesPrice: '현재 공급 시기 가격',
    adminNote: '발행자가 공급량을 증가시킬 수 있습니다',
    tokensOnInjective: '인젝티브 내 순환 토큰 수량',
    theAmountDisplayedMayNotBeInTheCorrectScale:
      '수량이 정확한 규모로 표시되지 않습니다',
    theInfoOfTokenExternalVerification:
      '이 토큰의 이름은 소스 네트워크에서 찾은 정보를 기반으로 합니다.',
    toast: {
      assetNotFound: '{denom}에 해당하는 자산을 찾을 수 없습니다.'
    },
    tabs: {
      assets: '토큰',
      'assets-smart-contracts': '스마트 컨트랙트'
    },
    stakingTabs: {
      'account-account-staking': '스테이킹 됨',
      'account-account-staking-unstake': '언스테이킹',
      'account-account-staking-restake': '리스테이킹'
    },
    denomHolders: {
      title: '홀더',
      value: '가치',
      address: '주소',
      percentage: '퍼센트',
      quantity: '수량량'
    }
  },
  wallet: {
    beta: '베타',
    wallet: '지갑',
    popular: '인기',
    address: '주소',
    connect: '연결',
    overview: '개요',
    connected: '연결된',
    disconnect: '연결해제',
    otherWallets: '다른 지갑',
    connectWallet: '지갑 연결',
    connectAWallet: '지갑 연결',
    connectedWallet: '연결된 지갑',
    disconnectWallet: '지갑 연결해제',
    connectUsingTorus: '원클릭 로그인',
    successfullyConnected: '성공적으로 연결된',
    connectUsingBrowser: '사용 중인 브라우저 지갑 연결',
    connectUsingHardware: '사용 중인 하드웨어 지갑 연결',
    connectWalletToUseNotifications:
      '알림 기능을 사용하려면 지갑을 연결하세요.',
    hardwareWallet: {
      getAddresses: '주소 생성',
      getMoreAddresses: '더 많은 주소 생성',
      selectAddressToConnect: '연결을 위한 주소 선택',
      getAddressNote: '주소를 식별 중입니다 ...'
    },
    trezor: {
      trezor: 'Trezor',
      trezorBip32: 'Trezor',
      trezorBip44: 'Trezor Bip44',
      derivationPath: '파생 경로',
      selectDerivationPath: '파생 경로 선택',
      note: '알림: 트레저 하드웨어 지갑을 원활하게 연결하려면 최신 버전의 크롬 브라우저를 사용 중인지 확인하고, Trezor 기기를 연결하고 언락했는지 확인하세요.'
    },
    ledger: {
      ledgerLive: '렛저 활성화',
      ledgerLegacy: '렛저 레거시',
      derivationPath: '파생 경로',
      selectDerivationPath: '파생 경로 선택',
      note: '알림: 렛저 하드웨어 지갑을 원활하게 연결하려면 최신 버전의 크롬 브라우저를 사용 중인지 확인하고, Ledger 기기가 연결되어 있고 잠금 해제되어 있으며 이더리움 앱이 열려 있어야 합니다.'
    },
    option: {
      leap: 'Leap',
      keplr: 'Keplr',
      ninji: 'Ninji',
      ledger: 'Ledger',
      'trezor-bip32': 'Trezor',
      'trezor-bip44': 'Trezor Bip44',
      phantom: 'Phantom',
      metamask: 'Metamask',
      'okx-wallet': 'OKX 지갑',
      BitGet: '비트겟 지갑',
      'trust-wallet': 'Trust 지갑',
      cosmostation: 'Cosmostation',
      'wallet-connect': 'Wallet Connect'
    }
  },
  account: {
    table: {
      staked: {
        reward: '리워드',
        amount: '수량',
        validator: '밸리데이터'
      },
      restaking: {
        amount: '수량',
        'destination-validator': '대상 밸리데이터',
        'source-validator': '출발 밸리데이터',
        'completition-time': '완료 시간'
      },
      unstaking: {
        amount: '수량',
        validator: '밸리데이터',
        'completition-time': '완료 시간'
      },
      balances: {
        price: '가격',
        amount: '수량',
        holding: '보유량',
        'usd-value': 'USD 가치',
        'unrealized-pnl': '미실현 손익',
        'in-use-reserved': '사용 중/예약됨',
        'available-balance': '사용 가능 잔액'
      },
      cw20Balances: {
        balance: '잔액',
        holding: '보유량',
        'contract-address': '컨트랙트 주소'
      }
    },
    cw20: 'CW',
    ibc: 'IBC',
    bank: '뱅크',
    total: '총',
    value: '가치',
    amount: '수량',
    native: '네이티브',
    price: '가격',
    staked: '스테이킹 됨',
    tokens: '토큰',
    reward: '리워드',
    address: '주소',
    balance: '잔액',
    holding: '보유량',
    unknown: '알 수 없음',
    unstake: '언스테이킹',
    restake: '리스테이킹',
    balances: '잔액',
    cosmwasm: 'CosmWasm',
    holdings: '보유 자산',
    usdValue: 'USD 가치',
    validator: '밸리데이터',
    allAssets: '모든 자산',
    assetType: '자산 유형',
    unbondings: '언본딩 중',
    injBalance: 'INJ 잔액',
    totalValue: '총 가치',
    details: '주소 상세',
    delegations: '위임',
    bridgedERC20: '브릿지된 ERC20',
    cw20Balances: 'CW20 잔액',
    pathToOrigin: '기존 경로',
    insuranceFund: '보험 기금',
    unrealizedPnl: '미실현 손익',
    inUseReserved: '사용 중/ 예약됨',
    tradingAccount: '트레이딩 계정',
    unknownNetwork: '알 수 없는 네트워크',
    contractAddress: '컨트랙트 주소',
    sourceValidator: '출발 밸리데이터',
    totalInjBalance: '총 INJ 잔액',
    whatDoesItMean: '무슨 의미인가요?',
    availableBalance: '사용 가능 잔액',
    claimableRewards: '클레임 가능한 리워드',
    completitionTime: '완료 시간',
    notFoundDescription: '다시 시도해 주세요.',
    latestTransactions: '최신 트랜잭션',
    noUnstakingFound: '언스테이킹된 자산이 없습니다.',
    insuranceFundToken: '보험 기금 토큰',
    noStakedFound: '스테이킹된 자산이 없습니다.',
    destinationValidator: '대상 밸리데이터',
    noTransactionsFound: '트랜잭션을 찾을 수 없습니다.',
    noRestakingFound: '리스테이킹된 자산이 없습니다.',
    tradingAccountBalances: '트레이딩 계정 잔액',
    isBalanceBreakdownEnabled: '잔액 세부 내역 포함',
    invalidDescription: '계정 주소를 정확히 다시 입력해 주세요',
    invalidTitle: '앗! 다음 계정 주소 형식이 잘못되었습니다:',
    notFoundTitle:
      '죄송합니다. {network} 네트워크에서 해당 계정을 찾을 수 없습니다:',
    ibcAssetPathDisplay:
      'IBC 자산은 자산의 원본 및 전송 경로를 고유하게 표시합니다.',
    amountIncludes:
      '수량에는 오픈 포지션의 마진 및 미실현 손익, 오픈 오더가 포함됩니다.',
    totalValueIncludes:
      '총 가치는 오픈 포지션의 마진, 미실현 손익, 오픈 오더 및 스테이킹 금액이 포함됩니다. 포지션 및 미실현 손익은 백그라운드에서 로드됩니다.',
    verified: '검증됨',
    internalVerification: '내부 검증됨',
    externalVerification: '외부 검증됨',
    unverified: '미검증',
    tokenFactory: '토큰 팩토리',
    tabs: {
      'account-account-index': '잔액',
      'account-account-transactions': '트랜잭션',
      'account-account-staking': '스테이킹',
      'account-account-nft': 'NFTs'
    },
    balanceTabs: {
      'account-account-index': '인젝티브',
      'account-account-index-cw20': 'CW20'
    }
  },
  markets: {
    table: {
      fundingRate: {
        time: '시간',
        'funding-rate': '펀딩 비율',
        'funding-interval': '펀딩 간격'
      },
      realTimeFundingRate: {
        markets: '마켓',
        'next-funding': '다음 펀딩',
        'hourly-interest-rate': '시간당 이자율',
        'estimated-funding-rate': '예상 펀딩 비율'
      },
      tradingRules: {
        markets: '마켓',
        'min-notional': '최소 명목 금액',
        'base-maker-fee': '기본 메이커 수수료',
        'base-taker-fee': '기본 테이커 수수료',
        'min-price-movement': '최소 가격 단위',
        'min-amount-movement': '최소 수량 단위',
        'initial-margin-ratio': '초기 마진 비율',
        'maintenance-margin-ratio': '유지 마진 비율'
      },
      marketInfo: {
        type: '유형',
        price: '가격',
        markets: '마켓',
        volume: '볼륨 (24시간)',
        'volume-in-usd': 'USD 가치 볼륨 (24시간)'
      }
    },
    allMarkets: '모든 마켓',
    allTypes: '모든 유형',
    baseDenom: '기본 식별자',
    baseMakerFee: '기본 메이커 비용',
    baseTakerFee: '기본 테이커 비용',
    derivative: '파생상품',
    estimatedFundingRate: '예상 펀딩 비율',
    exchangeRelayers: '거래소 / 릴레이어',
    fundingInterval: '펀딩 간격',
    fundingRate: '펀딩 비율',
    hourlyInterestRate: '시간당 이자율',
    includeLowVolumeMarkets: '저 거래량 마켓 포함',
    initialMarginRatio: '초기 마진 비율',
    lastFundingRate: '최근 펀딩 비율',
    lastTwelveHours: '최근 12시간',
    lastTwentyFourHours: '최근 24시간',
    maintenanceMarginRatio: '유지 마진 비율',
    minNotional: '최소 명목 금액',
    makerFeeRate: '메이커 비용 비율',
    market: '마켓',
    marketId: '마켓 Id',
    marketsInfo: '마켓 정보',
    marketDetails: '마켓 세부사항',
    tabs: {
      markets: '마켓 정보',
      'markets-realtime-funding-rate': '실시간 펀딩 비율',
      'markets-funding-rate-history': '펀딩 비율 히스토리',
      'markets-trading-rules': '거래 규칙'
    },
    marketType: '마켓 유형',
    minAmountMovement: '최소 수량 이동 단위',
    minPriceMovement: '최소 가격 이동 단위',
    minPriceTickSize: '최소 가격 틱 단위',
    minQuantityTickSize: '최소 수량 틱 단위',
    nextFunding: '다음 펀딩',
    oracleBase: '오라클 기준',
    oracleQuote: '오라클 표시',
    oracleType: '오라클 유형',
    oracleScaleFactor: '오라클 스케일 팩터',
    perDay: '일 기준',
    price: '가격',
    proposalId: '프로포절 ID',
    quoteDenom: '표시 식별자',
    searchMarket: '마켓 검색',
    spot: '현물',
    takerFeeRate: '테이커 수수료율',
    ticker: '티커',
    time: '시간',
    type: '유형',
    usd: 'USD',
    volume: '볼륨 (24시간)',
    volumeInUsd: 'USD 볼륨 (24시간)',
    oneHour: '1시간',
    futures: '선물',
    toast: {
      notFound: 'ID가 {id}인 마켓을 불러오는 데 실패했습니다.'
    }
  },
  spendPool: {
    table: {
      to: 'To',
      from: 'From',
      amount: '수량',
      timestamp: '타임스탬프',
      'block-height': '블록 높이'
    },
    title: '커뮤니티 지출 풀 / 분배 모듈',
    to: 'To CSP',
    from: 'From CSP/DM',
    enterAddress: '주소를 입력하세요',
    timeRange: '시간 범위 선택',
    communitySpendPool: '커뮤니티 지출 풀',
    cspDistributionModule: 'CSP/분배 모듈',
    enterAddressToSeeResults: '결과를 확인하려면 인젝티브 주소를 입력하세요'
  },
  transaction: {
    table: {
      transactions: {
        type: '유형',
        time: '시간',
        block: '블록',
        status: '상태',
        amount: '수량',
        'txn-hash': 'Txn 해시',
        'tx-hash-and-type': 'Tx 해시/유형',
        'status-and-amount': '상태/수량'
      }
    },
    txs: '트랜잭션',
    fee: '수수료',
    type: '유형',
    hash: '해시',
    time: '시간',
    memo: '메모',
    view: '보기',
    items: '항목',
    height: '블록 높이',
    events: '이벤트',
    sender: '보낸 사람',
    newTxs: '신규 트랜잭션',
    txHash: '트랜잭션 해시',
    message: '메시지',
    summary: '요약',
    txnHash: '트랜잭션 해시',
    messages: '메시지',
    errorLog: '에러 로그',
    exportCsv: 'CSV 내보내기',
    messageType: '메시지 유형',
    tokenTransfers: '토큰 전송',
    defiActivities: 'DeFi 활동',
    rawTransaction: '원시 트랜잭션',
    transactionHash: '트랜잭션 해시',
    updateTransactions: '트랜잭션 업데이트',
    transactionDetails: '트랜잭션 상세',
    gasUsedAndRequested: '가스 (사용됨/요청됨)',
    noTransactionsFound: '트랜잭션을 찾을 수 없습니다.',
    filter: {
      types: '유형',
      reset: '초기화',
      filters: '필터',
      allTypes: '모든 유형',
      messageType: '메시지 유형',
      selectAll: '전체 선택',
      clearAll: '전체 해제',
      resetMessages: '메시지 초기화'
    },
    stats: {
      totalTransactions: '총 트랜잭션',
      transactionsThirtyDays: '트랜잭션 (30일)',
      transactionsLast24Hours: '트랜잭션 (최근 24시간)',
      tps: 'TPS (최근 100 블록)'
    },
    voter: '투표자',
    signer: '서명자',
    details: '상세',
    proposer: '제안자',
    receiver: '수신자',
    depositor: '예치자',
    validator: '밸리데이터',
    subaccount: '서브계정',
    orchestrator: '오케스트레이터',
    hashInvalidTitle: '앗! 잘못된 트랜잭션 해시가 입력되었습니다:',
    hashInvalidDescription: '트랜잭션 해시를 정확히 입력해주세요.',
    notFoundTitle: '죄송합니다, 해당 트랜잭션을 {network}에서 찾을 수 없습니다',
    notFoundDescription:
      'Injective 익스플로러는 블록체인의 현재 상태(예: 트랜잭션 상태)에 대한 개요만 제공합니다. 이 익스플로러는 실제 트랜잭션을 제어하지 않습니다.',
    notFoundDescriptionPoint1:
      '1) 방금 트랜잭션을 제출했다면, 이 페이지를 새로고침하기 전에 최소 30초를 기다려 주세요.',
    notFoundDescriptionPoint2:
      '2) 트랜잭션이 아직 다른 노드의 TX 풀에 있을 수 있으며, 브로드캐스트를 대기 중일 수 있습니다.',
    notFoundDescriptionPoint3:
      '3) 네트워크가 혼잡할 경우, 트랜잭션이 표시되기까지 시간이 걸릴 수 있습니다.',
    notFoundDescriptionPoint4:
      '4) 1시간이 지나도 트랜잭션이 나타나지 않는다면, 보낸 사람이나 거래소/지갑/트랜잭션 제공자에게 문의해 주세요.',
    proposal: {
      proposal: '프로포절',
      yes: '찬성',
      abstain: '기권',
      no: '반대',
      noWithVeto: '반대 + 거부권'
    },
    summaryType: {
      MsgExecuteContractCompatSwap:
        '{sender}님이 {inputAmount} {inputSymbol}를 {outputAmount} {outputSymbol}(으)로 스왑 중'
    },
    eventLogs: {
      title: '이벤트 로그',
      logs: '로그'
    },
    claimId: '클레임 #',
    claimIdNote:
      'Ethereum 입금의 경우 여러 MsgDepositClaim 트랜잭션이 실행됩니다. 각 입금은 고유한 claimId로 식별됩니다.',
    generatingCsvSuccessMessage: 'CSV 파일이 성공적으로 생성되었습니다!',
    generatingCsvErrorMessage:
      'CSV 파일 생성 중 문제가 발생했습니다. 다시 시도해 주세요.'
  },
  tradeHistory: {
    table: {
      tradeHistory: {
        time: '시간',
        type: '유형',
        side: '방향',
        amount: '수량',
        market: '마켓',
        address: '주소',
        'trade-id': '거래 ID'
      }
    },
    buy: '매수',
    fee: '수수료',
    time: '시간',
    type: '유형',
    long: 'Long',
    side: '방향',
    sell: '매도',
    short: 'Short',
    event: '이벤트',
    filter: '필터',
    payout: '지급',
    market: '마켓',
    amount: '수량',
    address: '주소',
    tradeId: '거래 ID',
    timestamp: '타임스탬프',
    spotTrade: '현물 거래',
    timeRange: '시간 범위',
    allMarkets: '모든 마켓',
    blockHeight: '블록 높이',
    tradeActivity: '거래 활동',
    tradeIdDetails: '거래 ID 상세',
    tradingActivity: '거래 활동',
    tradeHistoryDaily: '거래 활동 (24시간)',
    clearFilters: '필터 초기화',
    feeRecipient: '수수료 수령자',
    subaccountId: '서브계정 ID',
    derivativeTrade: '파생상품 거래',
    filterByAddress: '주소별 필터',
    tradeHistoryDetails: '거래 내역 상세',
    toast: {
      notFound: 'id가 {id}인 거래를 불러오는 데 실패했습니다.'
    },
    tabs: {
      'trade-history-spot': '현물',
      'trade-history-derivatives': '파생상품'
    }
  },
  smartContracts: {
    table: {
      smartContracts: {
        'tx-hash': '트랜잭션 해시',
        address: '주소',
        creator: '생성자',
        executed: '실행됨',
        'last-executed-or-created': '최종 실행/생성',
        'contract-name-or-type': '컨트랙트 이름/유형'
      },
      wasm: {
        'tx-hash': '트랜잭션 해시',
        creator: '생성자',
        version: '버전',
        'id-or-type': 'ID/유형',
        instances: '인스턴스',
        'creation-date': '생성일'
      },
      tokenHolders: {
        address: '주소',
        balance: '잔액'
      }
    },
    tabs: {
      'smart-contracts': '컨트랙트',
      'smart-contracts-code': '코드'
    },
    contract: {
      fee: '수수료',
      time: '시간',
      type: '유형',
      admin: '관리자',
      denom: '식별자',
      funds: '자금',
      amount: '수량',
      height: '높이',
      result: '결과',
      codeId: '코드 ID',
      txHash: '트랜잭션 해시',
      address: '주소',
      balance: '잔액',
      created: '생성됨',
      creator: '생성자',
      decimal: '소수점',
      initMsg: '초기 메시지',
      cosmwasm: 'CosmWasm',
      balances: '잔액',
      contract: '컨트랙트',
      executed: '실행됨',
      tokenInfo: '토큰 정보',
      tokenHolders: '토큰 홀더',
      noInitMsg: '초기 메시지 없음',
      contractName: '컨트랙트 이름',
      creationDate: '생성일',
      lastExecuted: '최종 실행',
      smartContract: '스마트 컨트랙트',
      smartContracts: '스마트 컨트랙트',
      lastExecutedAt: '마지막 실행 시점',
      searchContracts: '컨트랙트 검색',
      updateContracts: '컨트랙트 업데이트',
      notFoundDescription: '다시 시도해 주세요.',
      smartContractDetails: '스마트 컨트랙트 상세',
      invalidTitle: '앗! 다음 컨트랙트 주소 형식이 잘못되었습니다:',
      invalidDescription: '컨트랙트 주소를 정확히 다시 입력해 주세요.',
      notFoundTitle:
        '죄송합니다. {network} 네트워크에서 해당 컨트랙트를 찾을 수 없습니다:',
      queryAndExecute: {
        max: '최대',
        copy: '복사',
        query: '조회',
        search: '검색',
        execute: '실행',
        balance: '잔액:',
        queryMsg: '조회 메세지',
        title: '조회/실행',
        jsonInput: 'JSON 입력',
        executeMsg: '실행 메시지',
        formatJSON: 'JSON 정리',
        queryResult: '조회 결과',
        attachFunds: '자금 추가',
        selectAsset: '자산 선택',
        enterAmount: '수량 입력',
        addMoreAssets: '자산 더 추가',
        suggestions: '메시지 제안',
        viewTransaction: '트랜잭션 보기',
        successfullyCopied: '복사 완료',
        successfullyExecuted: '실행 완료',
        connectToExecute: '컨트랙트를 실행하기 위해 지갑을 연결하세요',
        wallet: {
          connectWallet: '지갑 연결'
        },
        tabs: {
          'contract-contract-action': '조회',
          'contract-contract-action-execute': '실행'
        }
      }
    },
    code: {
      id: 'Id',
      type: '유형',
      idType: 'ID/유형',
      codeId: '코드 ID',
      txHash: '트랜잭션 해시',
      creator: '생성자',
      version: '버전',
      checksum: '체크섬',
      contract: '컨트랙트',
      wasmCode: 'Wasm 코드',
      instances: '인스턴스',
      wasmCodes: 'Wasm 코드',
      permission: '권한',
      codeDetail: '코드 상세',
      codeSchema: '코드 스키마',
      codeViewer: '코드 뷰어',
      proposalId: '프로포절 ID',
      updateCodes: '코드 업데이트',
      creationDate: '생성 일자',
      wasmCodeDetails: 'Wasm 코드 상세',
      permittedAddress: '허용된 주소',
      notFoundDescription: '다시 시도해 주세요.',
      invalidTitle: '아! 다음 코드 ID 형식이 잘못되었습니다:',
      invalidDescription: '코드 ID를 정확히 다시 입력해 주세요.',
      notFoundTitle:
        '죄송합니다, {network} 네트워크에서 해당 코드를 찾을 수 없습니다:'
    }
  },
  common: {
    via: '통해',
    code: '코드',
    back: '뒤로',
    sent: '전송됨',
    type: '유형',
    dApps: 'DApp',
    block: '블록',
    fail: '실패',
    amount: '수량',
    assets: '자산',
    blocks: '블록',
    wasmCode: '코드',
    status: '상태',
    failed: '실패함',
    inputs: '입력값',
    update: '업데이트',
    details: '상세',
    outputs: '출력값',
    account: '계정',
    success: '성공',
    markets: '마켓',
    chainId: '체인 Id',
    viewAll: '전체 보기',
    overview: '개요',
    received: '수신됨',
    contracts: '컨트랙트',
    search: '검색',
    time: '시간',
    timestamp: '타임스탬프',
    transaction: '트랜잭션',
    transactions: '트랜잭션',
    analytics: '분석',
    activity: '활동',
    all: '전체',
    from: '보낸 주소',
    to: '받는 주소',
    cosmWasm: 'CosmWasm',
    rawJson: '원본 JSON',
    noItems: '항목 없음.'
  },
  navigation: {
    hub: '허브',
    network: '네트워크',
    trading: '트레이딩',
    ecosystem: '생태계',
    validators: '밸리데이터',
    developers: '개발자'
  },
  network: {
    terra: '테라',
    evmos: '이브모스',
    axelar: '엑셀라',
    cosmos: '코스모스',
    osmosis: '오스모시스',
    ethereum: '이더리움',
    chihuahua: '치와와',
    persistence: '퍼시스턴스',
    injective: '인젝티브 체인',
    mainnet: '메인넷',
    testnet: '테스트넷'
  },
  toast: {
    codeIdCopied: '코드 ID가 클립보드에 복사되었습니다',
    addressCopied: '주소가 클립보드에 복사되었습니다',
    tradeIdCopied: '거래 ID가 클립보드에 복사되었습니다',
    marketIdCopied: '마켓 ID가 클립보드에 복사되었습니다',
    denomHashCopied: 'Denom 해시가 클립보드에 복사되었습니다',
    txHashCopied: '트랜잭션 해시가 클립보드에 복사되었습니다',
    blockNumberCopied: '블록 높이가 클립보드에 복사되었습니다',
    contractCopied: '컨트랙트 주소가 클립보드에 복사되었습니다',
    contractInitMsgCopied: '컨트랙트 초기 메세지가 클립보드에 복사되었습니다',
    contractFundCopied: '컨트랙트 자금 정보가 클립보드에 복사되었습니다',
    contractTokenInfoCopied: '컨트랙트 토큰 정보가 클립보드에 복사되었습니다'
  },
  networkError: {
    accountPageBankBalances: '네트워크 에러: 잔액을 불러올 수 없습니다.',
    accountPageCW20Balances: '네트워크 에러: 잔액을 불러올 수 없습니다.',
    accountPageSubaccountBalances: '네트워크 에러: 잔액을 불러올 수 없습니다.',
    accountPageTransactions: '네트워크 에러: 트랜잭션을 불러올 수 없습니다.',
    blockDetailsPage: '네트워크 에러: 블록을 불러올 수 없습니다.',
    blocksPageBlocks: '네트워크 에러: 블록을 불러올 수 없습니다.',
    contractDetailsPage: '네트워크 에러: 컨트랙트를 불러올 수 없습니다.',
    contractsPageContracts: '네트워크 에러: 컨트랙트를 불러올 수 없습니다.',
    contractsPageAccountsBalance:
      '네트워크 에러: 토큰 보유자를 불러올 수 없습니다.',
    contractPageTransactions: '네트워크 에러: 트랜잭션을 불러올 수 없습니다.',
    transactionDetailsPage: '네트워크 에러: 트랜잭션을 불러올 수 없습니다.',
    transactionsPageTransactions:
      '네트워크 에러: 트랜잭션을 불러올 수 없습니다.',
    wasmCodePageCodes: '네트워크 에러: 코드를 불러올 수 없습니다.',
    wasmCodeDetailsPage: '네트워크 에러: 코드를 불러올 수 없습니다.',
    communitySpendPool: '네트워크 에러: 트랜잭션을 불러올 수 없습니다.',
    denomHolders: '네트워크 에러: 토큰 보유자를 불러올 수 없습니다.'
  },
  noRecord: {
    accountPageBankBalances: '잔액이 없습니다.',
    accountPageCW20Balances: '잔액이 없습니다.',
    accountPageSubaccountBalances: '잔액이 없습니다.',
    accountPageTransactions: '트랜잭션이 없습니다.',
    blocksPageBlocks: '블록이 없습니다.',
    contractsPageContracts: '스마트 컨트랙트가 없습니다.',
    contractsPageAccountsBalance: '토큰 보유자가 없습니다.',
    genericNoRecordsFound: '기록이 없습니다.',
    tradeHistory: '거래 내역을 불러오는 데 실패했습니다.',
    transactionsPageTransactions: '트랜잭션이 없습니다.',
    wasmCodePageCodes: '곧 컨트랙트가 추가됩니다!',
    communitySpendPool: '결과가 없습니다.',
    denomHolders: '토큰 보유자가 없습니다.',
    noResultsFound: '{search}에 대한 결과가 없습니다'
  },
  pagination: {
    showRows: '행 수 표시'
  },
  FilterClearFilterBtn: '필터 초기화',
  FilterApplyBtn: '필터',
  notFound: '404 페이지를 찾을 수 없습니다',
  searchPlaceHolder: '트랜잭션, 블록 또는 주소를 검색하세요',
  FooterCopyRightMsg:
    'Copyright Â© {year} Injective Foundation. All rights reserved.',
  maintenance: {
    title: '예정된 점검 안내',
    description:
      '일부 업데이트 작업이 진행 중입니다. 이 기간 동안 일부 기능이 잠시 이용 불가능할 수 있습니다.',
    governance: '거버넌스 제안',
    governanceDescription: '최신 체인 업그레이드에 대한 세부 정보를 확인하세요',
    subscribe: '알림 구독하기',
    subscribeDescription: 'Notifi를 통해 실시간 알림을 받아보세요',
    footer:
      'InjScan을 더 나은 서비스로 만들고 있습니다. 여러분의 양해에 감사드리며 곧 다시 찾아뵙겠습니다!'
  },
  bgLoadingNote: 'UX 향상을 위해 외부 정보를 백그라운드에서 로딩 중입니다.',
  notFound404: {
    title: '페이지를 찾을 수 없습니다',
    description: '요청하신 페이지가 존재하지 않습니다.',
    backToHome: '홈페이지로 돌아가기기'
  },
  injNameDoesNotExist:
    '{injName}은 존재하지 않습니다. {link}에서 등록 가능합니다.',
  banners: {
    findOutMore: '자세히 알아보기'
  }
}
